<template>
  <div class="add-operation">
    <Breadcrumbs :items="breadcrumbs"/>
    <div class="content">
      <rp-operation-multistep
        @submit="submit"
        :patientEmail="patientEmail"
        v-model="operation"/>

      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="message"
          :onClick="alertAction"
        >
        </rp-alert>
      </rp-overlay>
    </div>
  </div>
</template>

<script>
  import Breadcrumbs from '@/components/Breadcrumbs'
  import OperationMultiForm from 'raypro_ui/src/components/ui/forms/OperationMultistep'
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import {createOperation} from 'raypro_ui/src/api/operations'
  import page from '@/mixins/page'

  export default {
    components: {
      'rp-operation-multistep': OperationMultiForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Breadcrumbs
    },

    mixins: [page],

    data() {
      return {
        active: false,
        message: 'Surgery added successfully!',
        userExists: false,
        operation: {
          'surgeon_id': '',
          'performed_at': '',
          'patient_ref': '',
          'patient_id': '',
          'operation_iols': [],
          'nurse_id': '',
          'hospital_id': '',
          'complex_surgery': false,
          'blended_vision': false,
          'aeon_drops_provided': false,
          'questionnaire_ids': [],
          welcome_email: true,
        },
        breadcrumbs: [
          {label: 'Add Surgery'}
        ],
        title: 'Add Surgery'
      }
    },

    mounted() {
      this.operation.nurse_id = this.$store.getters.authUser.id
    },

    computed: {
      operationPayload() {
        return {operation: this.operation}
      },
      patientEmail() {
        return this.$route.params.patientEmail
      }
    },

    methods: {
      alertAction() {
        this.$router.go()
      },
      submit() {
        createOperation(this.operationPayload)
          .then(() => {
            this.active = true
          })
          .catch((data) => {
            alert(`error ${data}`)
          })
      }
    }
  }
</script>

<style lang="sass">
  @import 'raypro_ui/src/styles/base/_variables.sass'
  @import 'raypro_ui/src/styles/helpers/_mixins.sass'

  .add-operation
</style>



// WEBPACK FOOTER //
// src/components/pages/Operations/AddOperation.vue